function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// // // <script type="text/javascript">
// // //   var kleveGlobalTranslations = {
// // //     "suggestions": "{{ 'general.search.suggestions' | t }}",
// // //     "matching_products": "{{ 'general.search.matching_products' | t }}",
// // //     "matching_content": "{{ 'general.search.matching_content' | t }}",
// // //     "how_can_we_help": "{{ 'general.search.how_can_we_help' | t }}",
// // //     "delivery": "{{ 'general.search.delivery' | t }}",
// // //     "money_back": "{{ 'general.search.money_back' | t }}",
// // //     "faq": "{{ 'general.search.faq' | t }}",
// // //     "contact": "{{ 'general.search.contact' | t }}",
// // //     "button_text": "{{ 'general.search.button_text' | t }}"
// // //   }
// // // </script>

var klevu_uc = {
    // uc_labelsTranslateObj: {
    //   matchingProducts: {
    //     'en': 'Best matches from shop',
    //     'de': 'Produkt Suchergebnisse',
    //     'fr': 'résultats de recherche',
    //     'es': 'mejores resultados en tienda',
    //     'it': 'migliori risultati dal negozio'
    //   },
    //   pagesHeading: {
    //     'en': 'Best matches from stories & info',
    //     'de': 'Blog & Editorial Suchergebnisse',
    //     'fr': 'résultats du blog & glossaire',
    //     'es': 'mejores resultados en blog e info',
    //     'it': 'migliori risultati dalle informazioni'
    //   }
    // },
    loadLayout: function loadLayout() {
        if ('undefined' !== typeof klevuLayoutVersion) {
            klevu_userOptions.minimumLetters = 1;
            klevu_userOptions.autoComplete = true;

            if ('undefined' !== typeof klevu_categorySearchEnabled && klevu_categorySearchEnabled) {
                klevu_userOptions.autoCompleteFilters = 'category';
            }

            if ('undefined' !== typeof klevu_cms_module_enabled && klevu_cms_module_enabled && klevu_cmsSearchEnabled || 'undefined' !== typeof klevu_shopifyStore && klevu_shopifyStore && 'undefined' !== typeof klevu_cmsEnabled && klevu_cmsEnabled) {
                klevu_userOptions.cmsEnabled = true;
                klevu_cmsApiKey = klevu_apiKey;

                if (klevu_userOptions.autoCompleteFilters.trim().length > 0) {
                    klevu_userOptions.autoCompleteFilters += ':cms';
                } else {
                    klevu_userOptions.autoCompleteFilters = 'category:cms';
                }
            } else {
                klevu_userOptions.cmsEnabled = false; //klevu_userOptions.autoCompleteFilters = 'category';
            }

            klevu_userOptions.layoutVersion = '2.0';
            klevu_userOptions.recordsPerPage = 3;

            if ('undefined' !== typeof klevu_productsToShowInSlimLayout) {
                klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout;
            }

            klevu_userOptions.fetchFilters = false;
            klevu_filtersEnabled = false;
            klevu_userOptions.rsPsClickBehaviour = 'redirect';

            if ('undefined' !== typeof klevu_rsPsClickBehaviour) {
                klevu_userOptions.rsPsClickBehaviour = klevu_rsPsClickBehaviour || 'redirect';
            }

            if ('undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showResultsData) {
                klevu_layout.renderResults = klevu_uc.showResultsData;
            }

            if ('undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.addAutocompleteLayoutToPage) {
                klevu_layoutSetup.addLayoutToPage = klevu_uc.addAutocompleteLayoutToPage;
            }

            if ('undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.showAutocompleteProducts) {
                klevu_layout.displayProductdata = klevu_uc.showAutocompleteProducts;
            }

            if ('undefined' !== typeof klevu_uc && 'undefined' !== typeof klevu_uc.displayNoResultData) {
                klevu_layout.displayNoResultData = klevu_uc.displayNoResultData;
            }

            klevu_uiLabels.otherContent = 'Content';

            if (window.innerWidth > 768) {
                klevu_uc_helpers.createModal();
                klevu_layoutSetup.addLayoutToPage(document.getElementById('klevu-search-modal')); // append klevu-fluid to the modal

                klevu_uc_helpers.openModal();
                klevu_uc_helpers.clearModalButton();
                klevu_uc_helpers.closeModal();
            } else {
                klevu_layoutSetup.addLayoutToPage(document.getElementsByTagName('body')[0]); // append klevu-fluid to the BODY on mobile
            }
        } else {
            setTimeout(klevu_loadLayout, 200);
        }
    },
    addAutocompleteLayoutToPage: function addAutocompleteLayoutToPage(parent) {
        var searchingAreaDiv, cmsContentDiv, cmsContentHeading, categoryDiv, productHeading, productDiv, fluidDiv, hoverDiv, hoverFluidDiv, suggestionsBlock, resultsBlock; // fluid div

        if (klevu_fluidLayoutEnabled) {
            fluidDiv = this.addElementToParent(parent, 'div', {
                "class": 'klevu-fluid'
            });
        } else {
            fluidDiv = parent;
        } // loader


        loaderContainerDiv = this.addElementToParent(fluidDiv, 'div', {
            "class": 'klevu-searching-area-l2 klevu-mobile',
            id: 'loaderContainer',
            style: 'display:none;top:140px!important;'
        });
        this.addLoaderDiv(loaderContainerDiv); // Arrow

        this.addElementToParent(fluidDiv, 'div', {
            "class": 'klevu-arrow',
            id: 'klevuArrow',
            style: 'display:none;'
        }); // searching area

        searchingAreaDiv = this.addElementToParent(fluidDiv, 'div', {
            "class": 'klevu-searching-area-l2 klevu-mobile',
            id: 'klevuSearchingArea',
            style: 'display:none;top:140px!important;'
        });

        if (klevu_showPopularSearches || klevu_showRecentSerches || klevu_userOptions.showRecentlyViewedItems || klevu_userOptions.showTrendingProducts) {
            hoverDiv = document.createElement('div');
            hoverDiv.setAttribute('class', 'klevu-pt-rs-hover');
            hoverDiv.setAttribute('id', 'klevu-pt-rs-hover');
            hoverDiv.style.display = 'none';

            if (klevu_fluidLayoutEnabled) {
                hoverFluidDiv = document.createElement('div');
                hoverFluidDiv.setAttribute('class', 'klevu-fluid');
                hoverFluidDiv.appendChild(hoverDiv);
                parent.appendChild(hoverFluidDiv);
            } else {
                parent.appendChild(hoverDiv);
            }

            var addDiv = false; // add popular searches div

            if (klevu_showPopularSearches) {
                addDiv = this.addPopularSearchesDiv(hoverDiv);
            } // add recent searches div


            if (klevu_showRecentSerches) {
                addDiv = this.addRecentSearchesDiv(hoverDiv);
            }

            if (!addDiv) {
                hoverDiv.style.display = 'none';
            }
        } // no-results div


        this.addElementToParent(searchingAreaDiv, 'div', {
            "class": 'klevuNoResults klevuNoResults-new',
            id: 'klevuSearchNoResults',
            style: 'display:none;'
        }); // banner ad block - top

        if ('undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds) {
            this.addElementToParent(searchingAreaDiv, 'div', {
                "class": 'klevu-banner-ad',
                id: 'klevuBannerAdTop',
                style: 'padding:0px;'
            });
        } // suggestions block


        suggestionsBlock = this.addElementToParent(searchingAreaDiv, 'div', {
            "class": 'klevuSuggestionsBlock',
            id: 'klevuSuggestionsBlock'
        });

        if (window.screen.width > 767) {
            // suggestions wrapper
            suggestionsWrapper = this.addElementToParent(suggestionsBlock, 'div', {
                "class": 'klevuSuggestionsWrapper klevu-mobile',
                id: 'klevuSuggestionsWrapper'
            }); // Autosuggestion

            this.addElementToParent(suggestionsWrapper, 'div', {
                "class": 'klevuAutoSuggestion-l2',
                id: 'klevuAutoCompleteArea',
                style: 'display:none;'
            });
            klevu_uc_helpers.howCanWeHelp(suggestionsWrapper);
        } else {
            // Autosuggestion
            this.addElementToParent(suggestionsBlock, 'div', {
                "class": 'klevuAutoSuggestion-l2',
                id: 'klevuAutoCompleteArea',
                style: 'display:none;'
            });
        } //results block


        resultsBlock = this.addElementToParent(suggestionsBlock, 'div', {
            "class": 'klevuResultsBlock',
            id: 'klevuResultsBlock'
        }); // Products

        productHeading = this.addElementToParent(resultsBlock, 'div', {
            "class": 'klevuSuggestionHeading',
            id: 'klevuProductHeading',
            style: 'display:none;'
        });
        productDiv = this.addElementToParent(resultsBlock, 'div', {
            "class": 'klevuSearchResults-l2',
            id: 'productsList',
            style: 'display:none;'
        }); // CMS

        cmsContentDiv = this.addElementToParent(suggestionsBlock, 'div', {
            "class": 'klevuAutoSuggestion-l2',
            id: 'klevuCmsContentArea',
            style: 'display:none;'
        });
        cmsContentHeading = this.addElementToParent(suggestionsBlock, 'div', {
            "class": 'klevuSuggestionHeading',
            style: 'display:none;'
        });
        cmsContentHeading.innerHTML = '<span class="klevuHeadingText">Pages</span>'; // category

        categoryDiv = this.addElementToParent(suggestionsBlock, 'div', {
            "class": 'klevuAutoSuggestion-l2',
            id: 'klevuCategoryArea',
            style: 'display:none;'
        });

        if (window.screen.width <= 767) {
            klevu_uc_helpers.howCanWeHelp(searchingAreaDiv);
        } // banner ad block - bottom


        if ('undefined' !== typeof klevu_showBannerAds && klevu_showBannerAds) {
            this.addElementToParent(searchingAreaDiv, 'div', {
                "class": 'klevu-banner-ad',
                id: 'klevuBannerAdBottom',
                style: 'padding:0px;'
            });
        } // powered by div


        if (!klevu_logoFreeSearch) {
            this.addPoweredByDiv(searchingAreaDiv);
        } // change Klevu default texts:


        klevu_uc.klevu_ChangeLabelsText();
    },
    klevu_ChangeLabelsText: function klevu_ChangeLabelsText() {
        if (window.innerWidth > 768) {
            // klevu_uiLabels.matchingProducts = typeof klevu_uc.uc_labelsTranslateObj.matchingProducts[klevu_lang] !== 'undefined' ? klevu_uc.uc_labelsTranslateObj.matchingProducts[klevu_lang] : klevu_uc.uc_labelsTranslateObj.matchingProducts.en;
            klevu_uiLabels.matchingProducts = kleveGlobalTranslations.matching_products; // klevu_uiLabels.pagesHeading = typeof klevu_uc.uc_labelsTranslateObj.pagesHeading[klevu_lang] !== 'undefined' ? klevu_uc.uc_labelsTranslateObj.pagesHeading[klevu_lang] : klevu_uc.uc_labelsTranslateObj.pagesHeading.en;

            klevu_uiLabels.pagesHeading = kleveGlobalTranslations.matching_content;
        }
    },
    showAutocompleteProducts: function showAutocompleteProducts(product) {
        var productHtml = '',
            trackingParams = '',
            imgAlt,
            imgAltDiv = document.createElement('div');
        product = klevu_productCustomizations(product);

        if (product.productImage.trim().length === 0) {
            product.productImage = klevu_userOptions.noImageUrl;
        }

        if (klevu_userOptions.openProductClicksInNewWindow) {
            additionalParams = ' target="_blank"';
        } else {
            additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
        }

        trackingParams = '{' + 'data: {' + "code: '" + escape(product.productCode) + "'," + "url: '" + escape(product.productUrl) + "'," + "name: '" + escape(product.productName) + "'," + "salePrice: '" + escape(product.salePrice) + "'," + "rating: '" + escape(product.rating) + "'," + 'position: ' + product.productPosition + ',' + "category: '" + escape(product.category) + "'" + '}' + '}';
        imgAltDiv.innerHTML = product.productName;
        imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || '';
        productHtml += '<li>';
        productHtml += '<a href="' + product.productUrl.replace(/"/g, '%22') + '" class="klevu-result-box-l2" ';

        if (klevu_commons.isMobileDevice()) {
            productHtml += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');"  >';
        } else {
            productHtml += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + ' >';
        }

        productHtml += '<div class="klevu-img-wrap-l2">';
        productHtml += '<img src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '" /></div>';

        if ('undefined' !== typeof klevu_showDiscountBadge && klevu_showDiscountBadge && product.discount != '' && product.discount != '0' && product.discount != '0.0') {
            if (klevu_uiLabels.discountBadgeText.indexOf('#') === -1) {
                productHtml += '<div class="klevu-discount-badge-l2">' + klevu_uiLabels.discountBadgeText + ' ' + Number(product.discount).toFixed(0) + '%</div>';
            } else {
                productHtml += '<div class="klevu-discount-badge-l2">' + klevu_uiLabels.discountBadgeText.replace('#', Number(product.discount).toFixed(0) + '%') + '</div>';
            }
        } // Customization. Add badges to slim layout.


        productHtml += klevu_uc_helpers.createBadgeSlim(productHtml, product); // Customization ENDS. Add badges to slim layout.

        productHtml += '<div class="klevu-name-desc-l2">';
        productHtml += '<div class="klevu-name-l2">' + product.productName + '</div>' + '<div class="klevu-desc-l2">' + product.productDescription + '</div>'; // show prices

        if (klevu_showPrices) {
            productHtml += '<div class="klevu-price-l2">';

            if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
                productHtml += klevu_commons.showOriginalAndSalePrices('SLIM', product, 'klevu-saleprice-l2', 'klevu-saleprice-l2 klevu-special-price-l2');
            } else {
                productHtml += klevu_commons.showProductPrices('SLIM', product, 'klevu-saleprice-l2', 'klevu-saleprice-l2 klevu-special-price-l2');
            }

            if (klevu_userOptions.vatCaption.trim().length > 0) {
                productHtml += '<span class="klevu-vat-caption-l2">(' + klevu_userOptions.vatCaption + ')</span>';
            }

            productHtml += '</div>';
        } // if (product.rating && product.rating !== '' && product.rating.trim().length > 0 && !isNaN(Number(product.rating)) && Number(product.rating) <= 5 && Number(product.rating) >= 0) {
        //   var starWidth = 20 * Number(product.rating);
        //   productHtml += '<div class="klevu-stars-small-l2"><div class="klevu-rating-l2" style="width:' + starWidth + '%;"></div></div>';
        // }

        productHtml += klevu_uc_helpers.generateRatingHTML(product);

        if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
            if (product.inStock && product.inStock === 'no') {
                productHtml += '<div class="klevu-out-of-stock-l2">' + klevu_userOptions.outOfStockCaption + '</div>';
            }
        }

        productHtml += '</div><div class="klevu-clear-left"></div></a></li>';
        return productHtml;
    },
    showResultsData: function showResultsData(response, callFrom) {
        var doc = document,
            noOtherDataAvailable = true,
            klevuSearchNoResult = doc.getElementById('klevuSearchNoResults'),
            arrowDiv = doc.getElementById('klevuArrow'); // // Customization. Add quick search popup to second input
        // var secondInputRecommendations = document.querySelector('#MainContent .klevu-pt-rs-hover'),
        // secondInputSearchResults = document.querySelector('#MainContent .klevu-searching-area-l2#klevuSearchingArea');
        // if(klevu_activeSearchBox !== undefined && klevu_activeSearchBox.id === "Search"){
        //   secondInputRecommendations.classList.add('klevu_secondLayout');
        //   secondInputSearchResults.classList.add('klevu_secondLayout');
        // } else {
        //   secondInputRecommendations.classList.remove('klevu_secondLayout');
        //   secondInputSearchResults.classList.remove('klevu_secondLayout');
        // }
        // hide loader

        this.hideLoader();

        if (klevu_searchedTerm.length === 0) {
            return;
        } //hide no-results div


        if (klevuSearchNoResult) {
            klevuSearchNoResult.style.display = 'none';
        } // show autosuggestion


        if (klevu_showAdvancedAutosuggestionLayout) {
            this.showAdvancedAutoSuggestions(response.autoComplete, noOtherDataAvailable, response.meta);
        } else {
            this.showAutoSuggestions(response.autoComplete, response.meta); // show cms content

            klevu_uc.showCmsContent(response.pages); // show filters

            this.showCategories(response.categories); // check if other data is available

            if (response.autoComplete && response.autoComplete.length > 0 || response.categories && response.categories.length > 0 || response.pages && response.pages.length > 0) {
                noOtherDataAvailable = false;
            } // show products


            klevu_uc.showProducts(response.meta, response.result, noOtherDataAvailable, response.popularProducts);

            if (!noOtherDataAvailable || response.result.length > 0) {
                klevu_commons.showBannerAdForGivenTerm(klevu_searchedTerm);
            } else {
                klevu_commons.showBannerAdForGivenTerm('');
            }
        }

        klevu_uc_helpers.searchSuggestions();
        doc.getElementById('klevuSearchingArea').style.cssText += ';display : block !important;';

        if (arrowDiv) {
            arrowDiv.style.display = 'none'; // removing !important added at the time of clearing results.
        }
    },
    showProducts: function showProducts(metaTags, products, noOtherDataAvailable, popularProducts) {
        var doc = document,
            totalResultsFound = 0,
            productHtml = '',
            maxNoOfResults = klevu_userOptions.recordsPerPage,
            i = 0,
            maxNoOfChars = 33,
            productListDiv = doc.getElementById('productsList'),
            productImage = '',
            productDesc = '',
            openTag,
            closeTag,
            desc = '',
            name = '',
            metaDesc = '',
            brand = '',
            code = '',
            salePrice = '',
            groupPrices = '',
            price = '',
            imageURL = '',
            currency = '',
            rating = '',
            displayPrice = '',
            totalVariants = '',
            url = '',
            discount = '',
            startPrice = '',
            toPrice = '',
            sku = '',
            productHeading = doc.getElementById('klevuProductHeading'),
            landingPageUrl = "",
            viewAllHtml = '',
            product,
            objectKey,
            productPosition = 0,
            descDiv = doc.createElement('div'),
            redirectUrl = klevu_commons.getRedirectUrlForSearchedTerm(klevu_searchedTerm);

        if ('undefined' !== typeof klevu_storeLandingPageUrl) {
            landingPageUrl = klevu_storeLandingPageUrl;
        }

        if ('undefined' !== typeof klevu_searchQueryParam && klevu_searchQueryParam) {
            landingPageUrl = klevu_commons.updateUrlParameter(landingPageUrl, klevu_searchQueryParam, "");
        } else {
            landingPageUrl = klevu_commons.updateUrlParameter(landingPageUrl, "q", "");
        }

        if (redirectUrl !== null) {
            landingPageUrl = redirectUrl;
        } else {
            landingPageUrl += encodeURIComponent(klevu_searchedTerm);
        }

        if (products.length > 0) {
            if (metaTags.totalResultsFound) {
                totalResultsFound = Number(metaTags.totalResultsFound);
            }

            productHeading.innerHTML = '<span class="klevuHeadingText">' + klevu_uiLabels.matchingProducts.replace('#', klevu_searchedTerm) + '</span>';
            viewAllHtml = '<a href="' + landingPageUrl + '" target="_parent" class="uc_viewMore">' + klevu_uiLabels.viewAllProducts.replace('#', totalResultsFound) + '</a>'; // Customization. Move View more for mobile. Start

            if (window.innerWidth > 768) {
                if (!klevu_layout.loaderPlaced) {
                    productHeading.innerHTML += '<span class="klevuLoader" id="klevu-loader-2">' + viewAllHtml + '</span>';
                } else {
                    productHeading.innerHTML += viewAllHtml;
                }
            } // Customization. Move View more for mobile. End


            productHeading.style.display = 'block';
            productHtml = '<ul>';

            for (i = 0; i < products.length && i < maxNoOfResults; i++) {
                name = products[i].name || '';
                metaDesc = products[i].shortDescription || products[i].shortDesc || products[i].desc || products[i].metaDesc || '';
                desc = metaDesc;
                brand = products[i].brand || '';
                code = products[i].id || '';
                salePrice = products[i].salePrice || '';
                price = products[i].price || '';
                imageURL = products[i].imageUrl || products[i].image || '';
                currency = products[i].currency || '';
                displayPrice = products[i].displayPrice || '';
                totalVariants = products[i].totalVariants || '';
                url = products[i].url || '';
                startPrice = products[i].startPrice || '';
                toPrice = products[i].toPrice || '';
                sku = products[i].sku || '';
                groupPrices = products[i].groupPrices || '';
                rating = products[i].rating || '';
                discount = products[i].discount || '';
                product = null;
                objectKey = null;
                productPosition = 1 + i;
                descDiv.innerHTML = desc;
                desc = descDiv.textContent || descDiv.innerText || ""; //description

                if (desc.length > maxNoOfChars) {
                    desc = desc.replace(/^(.{33}[^\s]*).*/, "$1") + ' ...';
                } //just making sure we have't cut any html tags while applying substring function


                openTag = desc.lastIndexOf("<b");
                closeTag = desc.lastIndexOf("</b>");

                if (openTag > closeTag) {
                    desc = desc.substring(0, openTag - 1);
                }

                product = {
                    productCode: code,
                    productImage: imageURL,
                    productBrand: brand,
                    productUrl: url,
                    productName: name,
                    productDescription: desc,
                    productPrice: price,
                    salePrice: salePrice,
                    currency: currency,
                    priceToDisplay: displayPrice,
                    startPrice: startPrice,
                    toPrice: toPrice,
                    totalProductVariants: totalVariants,
                    productSku: sku,
                    groupPrices: groupPrices,
                    rating: rating,
                    discount: discount,
                    productPosition: productPosition
                };

                for (objectKey in products[i]) {
                    if (products[i].hasOwnProperty(objectKey)) {
                        product[objectKey] = products[i][objectKey];
                    }
                }

                productHtml += klevu_layout.displayProductdata(product);
                descDiv.innerHTML = '';
            }

            productHtml += '</ul>';
            productListDiv.innerHTML = productHtml; // Customization. Move View more for mobile. Start

            if (window.innerWidth <= 768) {
                if (!klevu_layout.loaderPlaced) {
                    productListDiv.innerHTML += '<span class="klevuLoader" id="klevu-loader-2">' + viewAllHtml + '</span>';
                } else {
                    productListDiv.innerHTML += viewAllHtml;
                }
            } // Customization. Move View more for mobile. End

        } else {
            productHeading.style.display = 'none';
            productListDiv.innerHTML = '';

            if (noOtherDataAvailable) {
                var klevuNoResultDiv = doc.getElementById('klevuSearchNoResults');
                klevuNoResultDiv.innerHTML = klevu_layout.displayNoResultData(klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, popularProducts));
                klevuNoResultDiv.style.display = "block";
            }
        }

        productListDiv.style.display = "block";
    },
    showCmsContent: function showCmsContent(cmsContent) {
        var doc = document,
            cmsDiv = doc.getElementById('klevuCmsContentArea'),
            maxNoOfPages = 3,
            cmsHtml = '',
            i = 0,
            landingPageUrl = '',
            viewAllHtml = '';
        klevu_uiLabels.viewAllProducts = kleveGlobalTranslations.button_text;

        if ('undefined' !== typeof klevu_maxPagesToShow && klevu_maxPagesToShow) {
            maxNoOfPages = klevu_maxPagesToShow;
        }

        if (cmsContent && cmsContent.length > 0) {
            if ('undefined' !== typeof klevu_storeLandingPageUrl) {
                landingPageUrl = klevu_storeLandingPageUrl;
            }

            if ('undefined' !== typeof klevu_searchQueryParam && klevu_searchQueryParam) {
                landingPageUrl = klevu_commons.updateUrlParameter(landingPageUrl, klevu_searchQueryParam, '');
            } else {
                landingPageUrl = klevu_commons.updateUrlParameter(landingPageUrl, 'q', '');
            }

            cmsHtml = '<div class="klevuSuggestionHeading">';
            cmsHtml += '<span class="klevuHeadingText">' + klevu_uiLabels.pagesHeading + '</span>';
            viewAllHtml = '<a href="' + landingPageUrl + encodeURIComponent(klevu_searchedTerm) + '&viewContent=cms">' + klevu_uiLabels.viewAllProducts + '</a>';
            cmsHtml += viewAllHtml;

            if (!klevu_layout.loaderPlaced) {
                cmsHtml += '<span class="klevuLoader" id="klevu-loader-2"></span>';
                klevu_layout.loaderPlaced = true;
            }

            cmsHtml += '</div>';
            cmsHtml += '<ul>';

            for (i = 0; i < cmsContent.length && i < maxNoOfPages; i++) {
                // add images + descriptions to CMS Search Results
                cmsHtml += '<li><a class="klevu-customCmsItem" href="' + cmsContent[i].url + '">';
                cmsHtml += '<div class="klevu-customCmsItem__thumbWrapp"><img class="klevu-customCmsItem__thumb" src="' + (cmsContent[i].imageUrl ? cmsContent[i].imageUrl : klevu_userOptions.noImageUrl) + '" alt="Content Image" ></div>';
                cmsHtml += '<div class="klevu-customCmsItem__textWrapp">';
                cmsHtml += '<h5 class="klevu-customCmsItem__title">' + cmsContent[i].name + '</h5>';
                cmsHtml += '<p class="klevu-customCmsItem__shortDescr">' + cmsContent[i].shortDesc + '</p>';
                cmsHtml += '</div>';
                cmsHtml += '</a></li>';
            }

            cmsHtml += '</ul>';
            cmsDiv.innerHTML = cmsHtml;
            cmsDiv.style.display = 'block';
        } else {
            cmsDiv.style.display = 'none';
        }
    },
    showProductPrices: function showProductPrices(callFrom, product, salepriceClass, specialPriceClass) {
        if ('undefined' !== typeof klevu_groupListCategory && klevu_groupListCategory && product.hideGroupPrices && product.hideGroupPrices.indexOf(klevu_groupListCategory) !== -1) {
            return "";
        }

        var toReturn = '',
            salePriceToShow,
            i = 0,
            len,
            group,
            productGroupPrices,
            appendCurrencyAtLast,
            originalPriceWithCurrency,
            showNormalStartPrice = true,
            priceToSet,
            priceWithCurrency,
            priceFormatter,
            showProductOrSalePrice = true;

        if (product.productPrice.indexOf(product.currency) >= 0) {
            product.currency = '';
        }

        if (product.productPrice.trim() === '0') {
            product.productPrice = '';
        }

        if (klevu_currenciesAppendedAtEnd.indexOf(product.currency) !== -1) {
            appendCurrencyAtLast = true;
        } //code for currency switcher


        if ('undefined' !== typeof klevu_currentCurrencyCode && klevu_currentCurrencyCode && 'undefined' !== typeof klevu_currentCurrencyRates && klevu_currentCurrencyRates) {
            if (klevu_currentCurrencyCode !== product.currency && klevu_currencySymbols[klevu_currentCurrencyCode] !== product.currency) {
                if (klevu_currentCurrencyRates[klevu_currentCurrencyCode]) {
                    var rates = 0,
                        currencyData = klevu_currentCurrencyRates[klevu_currentCurrencyCode];

                    if (currencyData.split(":").length >= 2) {
                        rates = currencyData.split(":")[0];
                    }

                    if (rates > 0) {
                        if (product.productPrice) {
                            product.productPrice = (Number(product.productPrice) * rates).toString();
                        }

                        if (product.startPrice) {
                            product.startPrice = (Number(product.startPrice) * rates).toString();
                        }

                        if (product.toPrice) {
                            product.toPrice = (Number(product.toPrice) * rates).toString();
                        }

                        if (product.priceToDisplay) {
                            product.priceToDisplay = (Number(product.priceToDisplay) * rates).toString();
                        }

                        if (product.salePrice) {
                            product.salePrice = (Number(product.salePrice) * rates).toString();
                        }

                        if (currencyData.split(":")[1].trim().length > 0) {
                            product.currency = currencyData.split(":")[1];
                        }

                        if (currencyData.split(":").length > 2) {
                            appendCurrencyAtLast = currencyData.split(":")[2] === "true";
                        }
                    }
                }
            }
        }

        priceFormatter = klevu_userOptions.priceFormatter;

        if (!product.priceToDisplay && !product.startPrice && !product.toPrice || !product.totalProductVariants || product.totalProductVariants === '0') {
            priceToSet = Number(product.productPrice).formatMoneyForKlevu(priceFormatter.decimalPlaces, '', priceFormatter.thousandSeparator, priceFormatter.decimalSeparator);
            priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency, appendCurrencyAtLast);
            priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';

            if (product.productPrice.trim().length > 0 && product.salePrice.trim().length > 0 && product.productPrice != product.salePrice && product.productPrice !== '0.00' && product.productPrice !== '0' && Number(product.productPrice).toFixed(2) != Number(product.salePrice).toFixed(2)) {
                if (callFrom === 'SLIM') {
                    toReturn += klevu_layout.getPriceDivs('ORIG', priceWithCurrency, '');
                    salepriceClass = specialPriceClass;
                } else if (callFrom === 'BASIC') {
                    toReturn += klevu_layout.getPriceDivs('ORIG', priceWithCurrency, '');
                    salepriceClass = specialPriceClass;
                } else if (callFrom === 'LANDING') {
                    toReturn += klevu_getPriceDivs('ORIG', priceWithCurrency, '');
                    salepriceClass = specialPriceClass;
                }
            } else {
                if (product.productPrice.trim().length > 0 && product.productPrice !== '0.00' && product.productPrice !== '0.0' && product.productPrice !== '0') {
                    if (showProductOrSalePrice) {
                        if (callFrom === 'SLIM') {
                            toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        } else if (callFrom === 'BASIC') {
                            toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        } else if (callFrom === 'LANDING') {
                            toReturn += klevu_getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        }
                    }
                }
            }

            if (product.salePrice.trim().length > 0 && product.productPrice != product.salePrice && product.priceToDisplay.trim().length === 0 && product.salePrice !== '0.00' && product.salePrice !== '0' && product.salePrice !== '0.0' && Number(product.productPrice).toFixed(2) != Number(product.salePrice).toFixed(2)) {
                salePriceToShow = product.salePrice;

                if (product.groupPrices.trim().length > 0) {
                    if (document.getElementById('klevu_loginCustomerGroup')) {
                        klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup').innerText;
                    } else {
                        if ("undefined" === typeof klevu_loginCustomerGroup) {
                            klevu_loginCustomerGroup = "";
                        }
                    }

                    productGroupPrices = product.groupPrices.split(";");

                    for (i = 0, len = productGroupPrices.length; i < len; i++) {
                        group = productGroupPrices[i].split(":");

                        if (group[0].trim() === klevu_loginCustomerGroup) {
                            if (group.length === 3 && Number(group[2].trim()) < Number(product.salePrice)) {
                                salePriceToShow = group[2].trim();
                            }
                        }
                    }
                }

                priceToSet = Number(salePriceToShow).formatMoneyForKlevu(priceFormatter.decimalPlaces, '', priceFormatter.thousandSeparator, priceFormatter.decimalSeparator);
                priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency, appendCurrencyAtLast);
                priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';

                if (showProductOrSalePrice) {
                    if (callFrom === 'SLIM') {
                        toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    } else if (callFrom === 'BASIC') {
                        toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    } else if (callFrom === 'LANDING') {
                        toReturn += klevu_getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    }
                }
            } else {
                if (product.salePrice.trim().length > 0 && product.priceToDisplay.trim().length === 0 && product.salePrice !== '0.00' && product.salePrice !== '0' && product.salePrice !== '0.0') {
                    salePriceToShow = product.salePrice;

                    if (product.groupPrices.trim().length > 0) {
                        if (document.getElementById('klevu_loginCustomerGroup')) {
                            klevu_loginCustomerGroup = document.getElementById('klevu_loginCustomerGroup').innerText;
                        } else {
                            if ("undefined" === typeof klevu_loginCustomerGroup) {
                                klevu_loginCustomerGroup = "";
                            }
                        }

                        productGroupPrices = product.groupPrices.split(";");

                        for (i = 0, len = productGroupPrices.length; i < len; i++) {
                            group = productGroupPrices[i].split(":");

                            if (group[0].trim() === klevu_loginCustomerGroup) {
                                if (group.length === 3 && Number(group[2].trim()) < Number(product.salePrice)) {
                                    salePriceToShow = group[2].trim();
                                }
                            }
                        }
                    }

                    priceToSet = Number(salePriceToShow).formatMoneyForKlevu(priceFormatter.decimalPlaces, '', priceFormatter.thousandSeparator, priceFormatter.decimalSeparator);
                    priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency, appendCurrencyAtLast);
                    priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';

                    if (showProductOrSalePrice) {
                        if (callFrom === 'SLIM') {
                            toReturn = klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        } else if (callFrom === 'BASIC') {
                            toReturn = klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        } else if (callFrom === 'LANDING') {
                            toReturn = klevu_getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                        }
                    }
                }
            }
        }

        if (product.priceToDisplay.trim().length > 0) {
            if (callFrom === 'SLIM') {
                toReturn += klevu_layout.getPriceDivs('SALE', product.priceToDisplay, '', salepriceClass);
            } else if (callFrom === 'BASIC') {
                toReturn += klevu_layout.getPriceDivs('SALE', product.priceToDisplay, '', salepriceClass);
            } else if (callFrom === 'LANDING') {
                toReturn += klevu_getPriceDivs('SALE', product.priceToDisplay, '', salepriceClass);
            }
        }

        if (product.startPrice.trim().length > 0 && product.totalProductVariants && product.totalProductVariants != '0') {
            priceToSet = Number(product.startPrice).formatMoneyForKlevu(priceFormatter.decimalPlaces, '', priceFormatter.thousandSeparator, priceFormatter.decimalSeparator);

            if (priceToSet != '0.00') {
                showToLabel = true;
                priceWithCurrency = klevu_commons.addCurrencyToPrice(priceToSet, product.currency, appendCurrencyAtLast);
                priceWithCurrency = '<span class="money">' + priceWithCurrency + '</span>';

                if (showNormalStartPrice) {
                    if (callFrom === 'SLIM') {
                        toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    } else if (callFrom === 'BASIC') {
                        toReturn += klevu_layout.getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    } else if (callFrom === 'LANDING') {
                        toReturn += klevu_getPriceDivs('SALE', priceWithCurrency, '', salepriceClass);
                    }
                }
            }
        }

        try {
            if (toReturn.indexOf('class="klevu-saleprice-l2"') !== -1 && uc_helperFunctions.checkSiteCurrency()) {
                var spanWithId = 'class="klevu-saleprice-l2"' + 'data-variant-id="' + product.id + '"';
                toReturn = toReturn.replace('class="klevu-saleprice-l2"', spanWithId);
            }

            if (toReturn.indexOf('class="kuSalePrice"') !== -1 && uc_helperFunctions.checkSiteCurrency()) {
                var _spanWithId = 'class="kuSalePrice"' + 'data-variant-id="' + product.id + '"';

                toReturn = toReturn.replace('class="kuSalePrice"', _spanWithId);
            }
        } catch (e) {
            console.log(e);
        }

        return toReturn;
    },
    landingFilters: {
        loadingFiltersFor: "search-query",
        lastSelectedFilters: "",
        // function for showing filters from the given xml
        showFilters: function showFilters(filters) {
            var filterBox = document.getElementById('kuFilters'),
                i,
                len,
                j = 0,
                k = 0,
                filterBoxIds = new Array(),
                multiselectClass = '',
                filterByDoc = klevu_commons.isMobileDevice() ? document.getElementById("kuFilterRefineMobile") : document.getElementById("klevuNarrowByLabel");
            klevuLandingFilterTxt = '';
            filterBox.innerHTML = '';

            if ('undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
                multiselectClass = ' kuMulticheck';
            }

            if (filters && filters.length > 0) {
                filterBox.className = "kuFilters" + multiselectClass;

                for (i = 0, len = filters.length; i < len; i++) {
                    if (filters[i].key === 'Price Range' && !klevu_showPrices) {
                        continue;
                    }

                    filterBoxIds[j] = klevu_landingFilters.displayFiltersData(filters[i]);
                    j++;
                }

                filterBox.innerHTML = klevuLandingFilterTxt;

                if ('undefined' !== typeof filterByDoc && filterByDoc) {
                    if (klevuLandingFilterTxt.trim().length === 0) {
                        filterByDoc.style.display = "none";
                    } else {
                        filterByDoc.style.display = "block";
                    }
                }

                for (i = 0, len = filterBoxIds.length; i < len; i++) {
                    if (filterBoxIds[i] && filterBoxIds[i].trim() != '') {
                        document.getElementById(filterBoxIds[i]).style.height = "auto";
                    }
                }

                j = 0;

                for (k = 0, len = filters.length; k < len; k++) {
                    var key = filters[k].key.replace(' ', '_'),
                        filterOptions = filters[k].options;

                    for (i = 0; i < filterOptions.length; i++) {
                        var selected = filterOptions[i].isSelected,
                            kuid = i + key + '~text';

                        if (selected.trim() === 'true') {
                            klevu_landingFilters.showSelectedFilter(kuid, filterOptions[i].name, j, filters[k].label);
                            j++;
                        }
                    }
                }

                if ('undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider && klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
                    klevu_landingFilters.showSelectedFilter(null, klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0], j, null, 'Price-Range');
                    j++;
                }

                if (j === 0) {
                    klevu_landingFilters.showSelectedFilter(null, null, -1);
                } //below three lines solve rendering issue for mac browsers like chrome and safari


                filterBox.style.display = 'none';
                filterBox.offsetHeight;
                filterBox.style.display = 'block';

                if (document.getElementById('kuFilterRefineMobile') && klevu_commons.isMobileDevice() && (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768)) {
                    if (klevu_landingFilters.lastSelectedFilters === klevu_userOptions.selectedLandingFilters) {
                        klevu_landingFilters.showFiltersOnMobile(false);
                    } else {
                        klevu_landingFilters.showFiltersOnMobile(!(j === 0));
                    }

                    klevu_landingFilters.lastSelectedFilters = klevu_userOptions.selectedLandingFilters;
                }
            } else {
                filterBox.className = "kuFilters disableKuFilter" + multiselectClass;
            }
        },
        // function for showing other filters
        displayFiltersData: function displayFiltersData(filter) {
            if (filter) {
                var labelToPut = klevu_translateFilterLabel(filter.label).toUpperCase(),
                    pricingFilter = false,
                    msrpFilter = false,
                    filterBox = '',
                    filterOptions = filter.options,
                    key = filter.key.replace(' ', '_'),
                    label,
                    inStockFilter = false,
                    isAnyOptionSelected = false,
                    truncatedLabel,
                    hoverClass = "kuHover";

                if (filter.label.toLowerCase() === 'price range') {
                    pricingFilter = true;
                }

                if (filter.label === 'MSRP') {
                    msrpFilter = true;
                }

                if (filter.key === 'inStock') {
                    inStockFilter = true;
                }

                if (klevu_commons.isMobileDevice()) {
                    hoverClass = "";
                }

                if (filterOptions.length > 6) {
                    filterBox += '<div class="kuFilterBox ' + hoverClass + '" id="kuFilterBox-' + key + '">';
                } else {
                    filterBox += '<div class="kuFilterBox ' + hoverClass + '" style="height:auto;" id="kuFilterBox-' + key + '">';
                }

                filterBox += '<div class="kuFilterHead kuCollapse"' + ' id="kuFilterHead-' + key + '" onclick="klevu_landingFilters.collapseExpand(' + ' \'kuFilterHead-' + key + '\', \'kuFilterNames-' + key + '\', \'kuShowOpt-' + key + '\', \'kuHideOpt-' + key + '\', \'kuFilterBox-' + key + '\' );">' + labelToPut + '</div>' + '<div class="kuFilterNames" id="kuFilterNames-' + key + '">' + '<ul>';

                for (var i = 0, len = filterOptions.length; i < len; i++) {
                    var selected = filterOptions[i].isSelected,
                        kuid = i + key + '~text',
                        kuClass = '',
                        kuCounterClass = 'kuFilterTotal',
                        counterText = filterOptions[i].count,
                        onclickCall = 'klevu_landingFilters.sendQuery(\'' + kuid + '\', true );';

                    if (selected.trim() === 'true') {
                        kuClass = 'kuSelected';
                        kuCounterClass = 'kuFilterCancel';

                        if ('undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
                            counterText = filterOptions[i].count;
                            isAnyOptionSelected = true;
                        } else {
                            counterText = 'X';
                        }

                        onclickCall = 'klevu_landingFilters.cancelFilter(\'' + kuid + '\'); ';
                    }

                    label = filterOptions[i].name;

                    if (pricingFilter) {
                        label = klevu_commons.replaceCurrencyWithItsSymbol(label, klevu_storeLandingCurrency);

                        try {
                            var newLabelArr = label.split('-').map(function(price) {
                                price.trunc();
                                return "<span class=\"money\">".concat(price, "</span>");
                            });
                            label = newLabelArr.join(' - ');
                        } catch (error) {
                            console.log(error);
                        }

                        truncatedLabel = label;
                        label = '';
                    } else {
                        if (klevu_userOptions.truncateFilterLabel) {
                            truncatedLabel = label.trunc(18);
                        } else {
                            truncatedLabel = label;
                        }
                    }

                    filterBox += '<li id="' + i + key + '" class="' + kuClass + '"><a href="javascript:void(0);" onclick="' + onclickCall + '" title="' + label + '" target="_self"><span class="kuFilterLabel">' + truncatedLabel + '</span><span class="' + kuCounterClass + '">' + counterText + '</span></a></li>' + '<input type="hidden" id="' + kuid + '" value="' + klevu_commons.escapeHtml(filterOptions[i].value) + '"/>';
                }

                filterBox += '</ul></div></div>';

                if (filterOptions.length > 6) {
                    if (isAnyOptionSelected) {
                        filterBox = filterBox.replace('<div class="kuFilterBox ' + hoverClass + '" id="kuFilterBox-' + key + '">', '<div class="kuFilterBox ' + hoverClass + '" style="height:auto;" id="kuFilterBox-' + key + '">');
                    } else {
                        filterBox += '<div class="kuShowOpt" id="kuShowOpt-' + key + '" style="display:block;text-align:center;">' + '<a href="javascript:klevu_landingFilters.showAll( \'kuFilterBox-' + key + '\' );" title="' + klevu_uiLabels.showMore + '" target="_self"><img src="' + klevu_userOptions.viewMoreImageUrl + '" alt="' + klevu_uiLabels.showMore + '"/></a></div><div class="kuHideOpt" id="kuHideOpt-' + key + '" style="display:none;text-align:center;">' + '<a href="javascript:void(0);" onclick="klevu_landingFilters.hideAll(\'kuFilterBox-' + key + '\');" title="' + klevu_uiLabels.showLess + '" target="_self"><img src="' + klevu_userOptions.viewLessImageUrl + '" alt="' + klevu_uiLabels.showLess + '"/></a></div>';
                    }
                }

                klevuLandingFilterTxt += filterBox;

                if (filterOptions.length > 0 && filterOptions.length < 6) {
                    return 'kuFilterBox-' + key;
                }
            }
        },
        displayPricingSlider: function displayPricingSlider() {
            var labelToPut = klevu_translateFilterLabel('PRICE RANGE').toUpperCase(),
                filterBox = '',
                filterOptions = 1,
                key = 'Price-Range',
                kuid,
                i = 0,
                len,
                selected,
                kuClass,
                kuCounterClass,
                counterText,
                onclickCall,
                label,
                pricingFilterClass = 'klevuPriceRangeSlider';

            if (filterOptions.length > 6) {
                filterBox += '<div class="kuFilterBox" id="kuFilterBox-' + key + '">';
            } else {
                filterBox += '<div class="kuFilterBox" style="height:auto;" id="kuFilterBox-' + key + '">';
            }

            filterBox += '<div class="kuFilterHead kuCollapse"' + ' id="kuFilterHead-' + key + '" onclick="klevu_landingFilters.collapseExpand(' + ' \'kuFilterHead-' + key + '\', \'kuFilterNames-' + key + '\', \'kuShowOpt-' + key + '\', \'kuHideOpt-' + key + '\', \'kuFilterBox-' + key + '\' );">' + labelToPut + '</div>' + '<div class="kuFilterNames" id="kuFilterNames-' + key + '">';

            if ('undefined' !== typeof klevu_current_version && klevu_current_version) {
                klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '2.0.2');

                if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
                    pricingFilterClass = 'kuPriceRangeSlider';
                }

                klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '2.0.0');

                if (!isNaN(klevuPluginVersion) && klevuPluginVersion < 0) {
                    klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '1.2.5');

                    if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
                        pricingFilterClass = 'kuPriceRangeSlider';
                    }
                }
            }

            if ('undefined' !== typeof klevu_shopifyStore && klevu_shopifyStore) {
                pricingFilterClass = 'kuPriceRangeSlider';
            }

            filterBox += '<div class="' + pricingFilterClass + '"><div id="ku-price-range"></div>';
            filterBox += '<div > <span id="ku-from-price"></span>&nbsp; <span id="ku-to-price"></span></div></div>';
            filterBox += '</div></div>';
            return filterBox;
        },
        sendQuery: function sendQuery(kuid, first) {
            var selectedFilters,
                doc = document,
                formattedFilters = '',
                predefinedFilters = '',
                filtersBox = doc.getElementById('kuFilters'),
                checkBoxes,
                priceFilter = '';

            if (first) {
                doc.getElementById(kuid.split('~')[0]).className = 'kuSelected';
            }

            if ('undefined' !== typeof klevu_userFilterResults) {
                predefinedFilters = klevu_userFilterResults;
            }

            checkBoxes = getElementsByClassName('kuSelected', 'li');
            selectedFilters = '';

            for (var i = 0, len = checkBoxes.length; i < len; i++) {
                formattedFilters = klevu_commons.unescapeHtml(doc.getElementById(checkBoxes[i].id + '~text').value);

                if (predefinedFilters.indexOf(formattedFilters) !== -1) {
                    continue;
                }

                if (selectedFilters.trim() === '') {
                    selectedFilters += formattedFilters;
                } else {
                    selectedFilters += ";;" + formattedFilters;
                }
            }

            if ('undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider && klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
                priceFilter = ";;" + klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0];
            }

            klevu_userOptions.selectedLandingFilters = selectedFilters + priceFilter;

            if (klevu_addSelectedFiltersToUrl) {
                klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingFilters, klevu_productFilterParam);
            }

            klevu_pagination.landingStartPosition = 0;

            if ('undefined' === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            } //klevu_lpShowLoader();


            if (doc.getElementById("kuProductContent")) {
                doc.getElementById('kuProductContent').style.opacity = "0.3";
            }

            klevu_landingFilters.loadingFiltersFor = "filter-selection";
            klevu_search.fetchResults(doc.getElementById('searchedKeyword').value, 'klp');
            return false;
        },
        showAll: function showAll(boxId, link) {
            var doc = document,
                box = doc.getElementById(boxId),
                key = boxId.substring(boxId.indexOf('-') + 1, boxId.length);
            box.style.height = "auto";
            box.style.overflow = "visible";
            doc.getElementById('kuShowOpt-' + key).style.display = "none";
            doc.getElementById('kuHideOpt-' + key).style.display = "block";
        },
        // function for hiding filters
        hideAll: function hideAll(boxId) {
            var doc = document,
                box = doc.getElementById(boxId),
                key = boxId.substring(boxId.indexOf('-') + 1, boxId.length);
            box.style.height = "";
            box.style.overflow = "hidden";
            doc.getElementById('kuShowOpt-' + key).style.display = "block";
            doc.getElementById('kuHideOpt-' + key).style.display = "none";
        },
        showSelectedFilter: function showSelectedFilter(kuid, selectedFilter, i, filterLabel, filterType) {
            var doc = document,
                selectedFilterDoc = doc.getElementById('ku-search-filter-tags'),
                clearAllEl = doc.getElementById('kuClearAllFilters'),
                filterHeadText = '',
                priceFilter = '';

            if (selectedFilterDoc) {
                if (i === -1) {
                    selectedFilterDoc.innerHTML = "";
                    return;
                }

                if (i === 0) {
                    selectedFilterDoc.innerHTML = "";
                }

                if (filterLabel) {
                    filterHeadText = filterLabel + " : ";
                }

                if (undefined !== _typeof(filterType) && filterType === 'Price-Range') {
                    if (!doc.getElementById('kuPriceRangeTag')) {
                        selectedFilter = selectedFilter.split(':')[1];
                        filterHeadText = klevu_translateFilterLabel('PRICE RANGE').toUpperCase() + " : ";
                        selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> ' + filterHeadText + selectedFilter + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); " target="_self" href="#">x</a></span> ';
                    }
                } else {
                    if (filterLabel.toLowerCase() === 'price range') {
                        // customization starts
                        var selectedPrices = selectedFilter.split('-');
                        selectedFilter = "<span class=\"money\">".concat(selectedPrices[0], "</span> - <span class=\"money\">").concat(selectedPrices[1], "</span>");
                    } // customization ends


                    selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag"> ' + filterHeadText + selectedFilter + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelFilter(\'' + kuid + '\'); " target="_self" href="#">x</a></span> ';
                }

                if (doc.getElementById('kuClearAllFilters')) {
                    doc.getElementById('kuClearAllFilters').parentNode.removeChild(doc.getElementById('kuClearAllFilters'));
                }

                selectedFilterDoc.innerHTML += '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); " onkeydown="klevu_eventHandler.handleElementKeydownEvent(event, null, klevu_landingFilters.clearAllFilters);" tabindex="0"><a> ' + klevu_uiLabels.clearAll + '</a></span>';
            }
        },
        cancelFilter: function cancelFilter(id) {
            document.getElementById(id.split('~')[0]).className = "";
            klevu_landingFilters.sendQuery(id, false);
        },
        cancelPriceSliderFilter: function cancelPriceSliderFilter() {
            klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, '');
            klevu_landingFilters.sendQuery('', false);
        },
        clearAllFilters: function clearAllFilters() {
            var checkBoxes = getElementsByClassName('kuSelected', 'li');

            for (var i = 0, len = checkBoxes.length; i < len; i++) {
                checkBoxes[i].className = "";
            }

            if (document.getElementById('kuPriceRangeTag')) {
                klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, '');
            }

            klevu_landingFilters.sendQuery('', false);
        },
        collapseExpand: function collapseExpand(mainId, nameId, showId, hideId, filterId) {
            var doc = document,
                mainBox = doc.getElementById(mainId),
                nameBox = doc.getElementById(nameId),
                showBox = doc.getElementById(showId),
                hideBox = doc.getElementById(hideId),
                filterBox = doc.getElementById(filterId);

            if (mainBox.className.indexOf('kuCollapse') !== -1) {
                mainBox.className = 'kuFilterHead kuExpand';
                nameBox.style.display = 'none';

                if (showBox) {
                    showBox.style.display = 'none';
                }

                if (hideBox) {
                    hideBox.style.display = 'none';
                }

                klevu_landingFilters.filterHeight = filterBox.style.height;
                filterBox.style.height = "50px";
            } else if (mainBox.className.indexOf('kuExpand') !== -1) {
                mainBox.className = 'kuFilterHead kuCollapse';
                nameBox.style.display = 'block';

                if (showBox) {
                    showBox.style.display = 'block';
                }

                if (hideBox) {
                    hideBox.style.display = 'none';
                }

                if (showBox && hideBox) {
                    klevu_landingFilters.hideAll(filterId);
                } else {
                    filterBox.style.height = 'auto';
                }
            }
        },
        showFiltersOnMobile: function showFiltersOnMobile(updateRefineByDiv) {
            var doc = document,
                filtersDiv = doc.getElementById('kuFilters'),
                narrowByDiv = doc.getElementById('kuFilterRefineMobile');
            updateRefineByDiv = typeof updateRefineByDiv !== 'undefined' ? updateRefineByDiv : true;

            if (narrowByDiv.className.indexOf('kuCollapse') !== -1) {
                if (updateRefineByDiv) {
                    narrowByDiv.className = 'kuFilterRefineMobile kuExpand';
                    filtersDiv.style.cssText += ";display : none !important;";
                } else {
                    filtersDiv.style.cssText += ";display : block !important;";
                }
            } else if (narrowByDiv.className.indexOf('kuExpand') !== -1) {
                if (updateRefineByDiv) {
                    narrowByDiv.className = 'kuFilterRefineMobile kuCollapse';
                    filtersDiv.style.cssText += ";display : block !important;";
                } else {
                    filtersDiv.style.cssText += ";display : none !important;";
                }

                var filterBoxes = getElementsByClassName('kuFilterHead', 'div');

                for (var i = 0, len = filterBoxes.length; i < len; i++) {
                    if (filterBoxes[i].className.indexOf('kuCollapse') !== -1) {
                        filterBoxes[i].click();
                    }
                }
            }
        }
    },
    showLandingPageData: function showLandingPageData(product) {
        var toReturn = '',
            toAppendwithSalePrice = '',
            priceWithCurrency = '',
            appendCurrencyAtLast = false,
            salepriceClass = 'kuSalePrice',
            priceFormatter,
            priceToSet,
            showToLabel = false,
            additionalParams = '',
            keywords = document.getElementById('searchedKeyword').value,
            trackingParams = "",
            trackingEventHtml = "",
            i = 0,
            j = 0,
            currentSwatch,
            swatchEventHandlerHtml,
            swatchFocusHandler,
            swatchBlurHandler,
            swatchColor,
            swatchCount = 0,
            swatchesShown = false,
            swatchesHtml = "",
            totalSwatchesToShow = 5,
            validSwatch = true,
            swatchGradientCSS = '',
            imgAlt,
            imgAltDiv = document.createElement('div'),
            additionalFlags = product.additionalDataToReturn ? JSON.parse(product.additionalDataToReturn) : false;
        product = klevu_productCustomizations(product);
        product.additionalFlags = additionalFlags;

        if (product.productImage.trim().length === 0) {
            product.productImage = klevu_userOptions.noImageUrl;
        }

        if (klevu_userOptions.openProductClicksInNewWindow) {
            additionalParams = ' target="_blank"';
        } else {
            additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"';
        }

        trackingParams = '{' + 'data: {' + 'code: \'' + escape(product.productCode) + '\',' + 'url: \'' + escape(product.productUrl) + '\',' + 'name: \'' + escape(product.productName) + '\',' + 'salePrice: \'' + escape(product.salePrice) + '\',' + 'rating: \'' + escape(product.rating) + '\',' + 'position: ' + product.productPosition + ',' + 'category: \'' + escape(product.category) + '\',' + 'sku: \'' + escape(product.sku) + '\'' + '},' + 'apiKey: null,' + 'keywordsLP: \'' + escape(keywords) + '\'' + '}';

        if (klevu_commons.isMobileDevice()) {
            trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" target="_self">';
        } else {
            trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + trackingParams + ', klevu_analytics.trackClickedProduct);" ' + additionalParams + '>';
        }

        try {
            toReturn += '<li>';
            toReturn += '<div class="klevuImgWrap">';
            toReturn += '<a  onfocus="klevu_eventHandler.handleProductFocusEvent(\'kuAddtocart-' + escape(product.productCode) + '\', event);"' + 'href="' + product.productUrl.replace(/"/g, "%22") + '" ';

            if (klevu_userOptions.showRolloverImage && product.imageHover) {
                toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');" ' + ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover) + '\', \'klevuProductImage-' + product.id + '\');" ';
            }

            imgAltDiv.innerHTML = product.productName;
            imgAlt = imgAltDiv.textContent || imgAltDiv.innerText || "";
            toReturn += ' ' + trackingEventHtml + '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage + '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(imgAlt) + '"/>';
            toReturn += '</a></div>';

            if (klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0) {
                totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;

                for (i = 0; i < totalSwatchesToShow; i++) {
                    currentSwatch = product.swatches.swatch[i];

                    if (currentSwatch.image) {
                        swatchesShown = true;

                        if (currentSwatch.swatchImage && currentSwatch.swatchImage.indexOf("#") === 0) {
                            swatchColor = currentSwatch.swatchImage.split(";");
                            currentSwatch.swatchImage = '';
                        } else {
                            swatchColor = currentSwatch.color.replace(/ /g, "").replace(/-/g, "");
                        }

                        validSwatch = true;

                        if ("object" === _typeof(swatchColor)) {
                            for (j = 0; j < swatchColor.length; j++) {
                                if (swatchColor[j] && !klevu_commons.isValidCSSColor(swatchColor[j])) {
                                    validSwatch = false;
                                    break;
                                }
                            }
                        } else {
                            if (!currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor)) {
                                validSwatch = false;
                            }

                            if (!klevu_commons.isValidCSSColor(swatchColor)) {
                                swatchColor = '';
                            }
                        }

                        if (!validSwatch) {
                            swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
                        } else {
                            swatchesHtml += '<div class="klevuSwatchItem">';
                        }

                        swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
                        swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';

                        if (klevu_commons.isMobileDevice()) {
                            swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
                        } else {
                            swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler + '" onmouseenter = "' + swatchFocusHandler + '" onfocus = "' + swatchFocusHandler + '" onblur = "' + swatchBlurHandler + '" ';
                        }

                        swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;

                        if ("object" === _typeof(swatchColor)) {
                            var colorPercent = 100.00 / swatchColor.length;
                            swatchGradientCSS = 'linear-gradient(-45deg,';

                            for (j = 0; j < swatchColor.length; j++) {
                                swatchGradientCSS += j === 0 ? ' ' : ', ';
                                swatchGradientCSS += swatchColor[j] + ' ' + colorPercent * j + '%';
                                swatchGradientCSS += ', ' + swatchColor[j] + ' ' + colorPercent * (j + 1) + '%';
                            }

                            swatchGradientCSS += ' );';
                            swatchesHtml += ' style = "background-image: ' + swatchGradientCSS + 'background-image: -webkit-' + swatchGradientCSS + 'background-image: -moz-' + swatchGradientCSS + 'background-image: -o-' + swatchGradientCSS + 'background-image: -ms-' + swatchGradientCSS + '" title="' + currentSwatch.color + '">';
                        } else {
                            swatchesHtml += ' style = "background-color:' + swatchColor + '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '" target="_self">';
                        }

                        swatchesHtml += '</a></div>';
                    } else {
                        swatchCount += 1;
                    }
                }

                if (product.swatches.swatch.length > totalSwatchesToShow) {
                    swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
                }

                if (!swatchesShown) {
                    swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
                } else {
                    swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
                }

                swatchCount += product.swatches.numberOfAdditionalVariants ? +product.swatches.numberOfAdditionalVariants : 0;

                if (swatchCount > 0 && swatchesShown) {
                    swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' + '<a href = "' + product.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + trackingEventHtml + '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
                }

                swatchesHtml += '</div>';
                toReturn += swatchesHtml;
            }
        } catch (e) {}

        if ('undefined' !== typeof klevu_showDiscountBadge && klevu_showDiscountBadge && product.discount != '' && product.discount != '0' && product.discount != '0.0') {
            if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
                toReturn += '<div class="kuDiscountBadge">' + klevu_uiLabels.discountBadgeText + ' ' + Number(product.discount).toFixed(0) + '%</div>';
            } else {
                toReturn += '<div class="kuDiscountBadge">' + klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") + '</div>';
            }
        }

        toReturn += '<div class="kuNameDesc">';
        toReturn += '<div class="kuName"><a tabindex="-1" href="' + product.productUrl.replace(/"/g, "%22") + '" ' + trackingEventHtml;
        toReturn += product.productName + '</a></div>';
        toReturn += '<div class="kuDesc">' + product.productDescription + '</div>'; // toReturn += klevu_landingProductElements.showRating(product);

        toReturn += '</div>';
        toReturn += '<div class="kuPrice">';

        if (klevu_showPrices) {
            toReturn += klevu_landingProductElements.showPrices(product, salepriceClass);
        }

        toReturn += klevu_uc_helpers.generateRatingHTML(product);

        if (klevu_userOptions.vatCaption.trim().length > 0) {
            toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
        }

        if (product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown) {
            if (klevu_uiLabels.variants.indexOf("#") === -1) {
                toReturn += '<div class="klevu-variants">+' + product.totalProductVariants + ' ' + klevu_uiLabels.variants + '</div>';
            } else {
                toReturn += '<div class="klevu-variants">' + klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
            }
        }

        if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
            if (product.inStock && product.inStock === 'no') {
                toReturn += '<div class="klevu-out-of-stock">' + klevu_userOptions.outOfStockCaption + '</div>';
            }
        }

        toReturn += '</div>';

        if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
            toReturn += klevu_landingProductElements.showAddtocart(product);
        }

        toReturn += '<div class="kuClearLeft"></div>';
        toReturn += '</li>';
        return toReturn;
    }
};
var klevu_uc_helpers = {
    createModal: function createModal() {
        var bodyEl = document.getElementsByTagName('body')[0] !== undefined ? document.getElementsByTagName('body')[0] : false;
        if (!bodyEl) return;
        var formhtml = '<div id="klevu-section-search-modal" class="klevu-section"><section class="klevu-search-modal modal" id="klevu-search-modal" data-section-type="klevu-search-modal" ><button class="klevu-search-modal__close modal__close modal__close--primary" id="klevu-search-modal__close" aria-label="Close modal" data-micromodal-close=""><svg viewBox="0 0 32 32" class="icon icon__close" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M15 27.805c7.06 0 12.805-5.744 12.805-12.805C27.805 7.94 22.06 2.195 15 2.195 7.94 2.195 2.195 7.94 2.195 15c0 7.06 5.744 12.805 12.805 12.805zM15 0c8.27 0 15 6.73 15 15s-6.73 15-15 15S0 23.27 0 15 6.73 0 15 0zm7.178 7.822a1.097 1.097 0 0 1 0 1.551L16.552 15l5.626 5.626a1.097 1.097 0 1 1-1.552 1.552L15 16.552l-5.626 5.626a1.094 1.094 0 0 1-1.552 0 1.097 1.097 0 0 1 0-1.552L13.448 15 7.822 9.373a1.097 1.097 0 1 1 1.552-1.551L15 13.448l5.627-5.626a1.097 1.097 0 0 1 1.551 0z" id="a"></path></svg></button><div class="klevu-search-modal__content is-loaded"><form action="/pages/search-results" method="get" role="search"><div class="klevu-search-modal__field"><input type="search" name="q" id="klevu-search-modal__input" autocomplete="off" maxlength="255"><button type="submit" class="klevu-search-modal__submit"><svg viewBox="0 0 32 32" class="icon icon__search" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M11.918 21.37c-5.212 0-9.452-4.24-9.452-9.452s4.24-9.452 9.452-9.452 9.452 4.24 9.452 9.452-4.24 9.452-9.452 9.452m17.72 5.704l-8.113-8.114a11.852 11.852 0 0 0 2.31-7.042C23.836 5.346 18.49 0 11.919 0 5.346 0 0 5.346 0 11.918c0 6.571 5.346 11.918 11.918 11.918 3.052 0 5.838-1.155 7.949-3.048l8.028 8.029c.24.24.557.361.872.361a1.232 1.232 0 0 0 .872-2.105" id="a"></path></svg><span class="icon-fallback-text">Search</span></button><button class="cu_blur-input-btn" id="cu_blur-input-btn" title="Clear Search Term"></button></div></form></div></section></div>';
        bodyEl.insertAdjacentHTML('beforeend', formhtml);
    },
    closeModal: function closeModal() {
        document.getElementById('klevu-search-modal__close').addEventListener('click', function() {
            document.getElementById('klevu-search-modal').classList.remove('is-open');
        });
        this.escapeKeyPressed();
    },
    escapeKeyPressed: function escapeKeyPressed() {
        document.onkeydown = function(evt) {
            evt = evt || window.event;

            if (evt.keyCode == 27) {
                document.getElementById('klevu-search-modal').classList.remove('is-open');
            }
        };
    },
    openModal: function openModal() {
        // if (window.innerWidth > 768) {
        var searchInput = document.querySelectorAll('input[name="q"]').length > 1 ? document.querySelectorAll('input[name="q"]') : false;
        if (!searchInput) return;
        searchInput.forEach(function(el) {
            el.addEventListener('click', function(e) {
                document.getElementById('klevu-search-modal').classList.add('is-open');
                document.getElementById('klevu-search-modal').querySelector('input[name="q"]').focus();
            });
        }); // }
    },
    clearModalButton: function clearModalButton() {
        var blurBTN = document.getElementById('cu_blur-input-btn') !== undefined ? document.getElementById('cu_blur-input-btn') : false;

        if (blurBTN) {
            blurBTN.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                this.parentElement.querySelector('input').value = '';
                this.parentElement.querySelector('input').focus();
            });
        }
    },
    createBadgeSlim: function createBadgeSlim(product) {
        var html = '';
        var discountBadge = '-15%';
        var newInBadge = 'NEW IN';
        var twinPackBadge = 'TWIN PACK';
        html += '<div class="klevu-badge-container">';
        addBadge(product['label--Save-15'], 'label--Save-15', discountBadge);
        addBadge(product['label--sticker-new-in'], 'label--sticker-new-in', newInBadge);
        addBadge(product['label--sticker-twin-pack'], 'label--sticker-twin-pack', twinPackBadge);
        html += '</div>';

        function addBadge(responseItem, htmlClass, badgeText) {
            if (typeof responseItem !== 'undefined' && responseItem.length > 0) {
                html += '<div class="klevu-badge__item ' + htmlClass + '"><span class="klevu-badge-content">' + badgeText + '</span></div>';
            }
        }

        return html;
    },
    howCanWeHelp: function howCanWeHelp(searchDiv) {
        //static block
        var staticDiv = klevu_layoutSetup.addElementToParent(searchDiv, 'div', {
            "class": 'klevuAutoSuggestion-l2',
            id: 'klevuStaticArea',
            style: 'display:block;'
        });
        var staticDivHead = klevu_layoutSetup.addElementToParent(staticDiv, 'div', {
            "class": 'klevuSuggestionHeading'
        });
        staticDivHead.innerHTML = '<span class="klevuHeadingText">' + kleveGlobalTranslations.how_can_we_help + '</span>';
        var staticDivList = klevu_layoutSetup.addElementToParent(staticDiv, 'ul', {
            "class": 'klevuULStaticAreaList'
        });
        staticDivList.innerHTML += '<li><a href="https://www.currentbody.com/pages/delivery-returns">' + kleveGlobalTranslations.delivery + '</a></li>';
        staticDivList.innerHTML += '<li><a href="https://www.currentbody.com/pages/customer-satisfaction-money-back-guarantee">' + kleveGlobalTranslations.money_back + '</a></li>';
        staticDivList.innerHTML += '<li><a href="https://currentbody.zendesk.com/hc/en-us">' + kleveGlobalTranslations.faq + '</a></li>';
        staticDivList.innerHTML += '<li><a href="https://www.currentbody.com/pages/contact-us">' + kleveGlobalTranslations.contact + '</a></li>';
        return staticDiv;
    },
    showCMSbyDefault: function showCMSbyDefault() {
        // LOAD CMS TAB IF "viewContent=cms" PRESENT IN URL
        if (window.location.search.indexOf('viewContent=cms') !== -1) {
            window.location.search.replace('&viewContent=cms', '');
            var oldWindowURL = window.location.href; // var newWindowURL = oldWindowURL.substring(0, oldWindowURL.length - [16]);

            var newWindowURL = oldWindowURL.replace('&viewContent=cms', '');
            window.history.pushState(null, null, newWindowURL);
            setTimeout(function() {
                klevu_changeKuTab('other');
            }, 500);
        }
    },
    searchSuggestions: function searchSuggestions() {
        if (document.getElementById('bc-sf-search-box-mobile') === null) return;
        var suggestionsArr = Array.prototype.slice.call(document.querySelectorAll('#klevu_acList a'));

        if (suggestionsArr.length > 0) {
            suggestionsArr.forEach(function(link) {
                link.removeAttribute('onmousedown');

                link.onclick = function(event) {
                    event.preventDefault();
                    var newSearchTerm = link.innerText;

                    if (newSearchTerm === klevu_searchedTerm) {
                        return;
                    }


                    document.getElementById('klevu-search-modal__input').value = newSearchTerm;


                    klevu_search.handleSearchQuery(newSearchTerm);
                    klevu_searchedTerm = newSearchTerm;
                };
            });
        }
    },
    generateRatingHTML: function generateRatingHTML(product) {

        try {
            var ratingResponse = typeof product.ProductListingSnippet !== 'undefined' && product.ProductListingSnippet !== '' ? product.ProductListingSnippet : '';
            var ratingText = ratingResponse.split('out of 5')[0];
            var ratingNumber = typeof ratingText !== 'undefined' ? Number(ratingText.toLowerCase().replace("rated", "")) : 0;

            if (ratingResponse == "") {
                var reviewsText = "";
            } else {

                var reviewsText = ratingResponse.split('out of 5')[1];
                reviewsText = reviewsText.split('Based on')[0];
            }

            var reviewsNumber = typeof reviewsText !== 'undefined' ? Number(reviewsText.toLowerCase().replace("reviews", "")) : 0;
            var reviewsPercent = ratingNumber !== 0 ? ratingNumber * 100 / 5 : 0;

            if (ratingResponse) {
                return "\n        <div class=\"grid-view-item__reviews\"><div class=\"mobile-text-center\"><div class=\"okeReviews okeReviews--theme\">\n          <div class=\"okeReviews-reviewsSummary js-okeReviews-reviewsSummary\">\n            <div class=\"okeReviews-reviewsSummary-starRating\">\n              <span class=\"okeReviews-starRating okeReviews-starRating--small\">\n                <span class=\"okeReviews-a11yText\">".concat(ratingResponse, "</span>\n                <span class=\"okeReviews-starRating-indicator\" role=\"presentation\">\n                  <span class=\"okeReviews-starRating-indicator-layer\"></span>\n                  <span class=\"okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground\" style=\"width: ").concat(reviewsPercent, "%\"></span>\n                </span>\n              </span>\n              </div><div class=\"okeReviews-reviewsSummary-ratingCount\">").concat(reviewsText, "</div></div>\n            </div>\n          </div>\n        </div>");
            }
            return "";
        } catch (error) {
            console.log(error);
        }
    }
};

function klevu_uc_productCustomizations(product) {
    var productImage = product.image ? product.image : '',
        productImageUrl = product.imageUrl ? product.imageUrl : '',
        productHoverImage = product.imageHover ? product.imageHover : '',
        productSize = '_500x500',
        oldSize = '_medium';

    function changeImageSize(img, url, hov, size, oldSize) {
        product.image = img.indexOf(oldSize) !== -1 ? img.replace(oldSize, size) : img;
        product.imageUrl = url.indexOf(oldSize) !== -1 ? url.replace(oldSize, size) : url;
        product.imageHover = hov.indexOf(oldSize) !== -1 ? hov.replace(oldSize, size) : hov;
        product.productImage = product.image;
    }

    changeImageSize(productImage, productImageUrl, productHoverImage, productSize, oldSize); // Set default Swatches Image

    if (product.swatches.swatch.length >= 1) {
        var prodImg = typeof product.image !== 'undefined' && product.image !== '' ? product.image : typeof product.imageUrl !== 'undefined' && product.imageUrl !== '' ? product.imageUrl : '';

        for (var i = 0; i < product.swatches.swatch.length; i++) {
            if (product.swatches.swatch[i].image === '') {
                product.swatches.swatch[i].image = prodImg;
            }
        }
    }

    return product;
}

function screenWidthCheck(screenWidth) {
    if (!screenWidth) screenWidth = 748;
    var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return widthOfScreen <= screenWidth;
} // function klevu_afterLandingResultsLoaded (results) {
//   klevu_uc_helpers.showCMSbyDefault();
// }


var uc_helperFunctions = {
    checkSiteCurrency: function checkSiteCurrency() {
        var selectToTrack = document.getElementById('storeswitcher');
        var currencyToCheck = ['GBP', 'USD', 'CHF'];

        if (selectToTrack) {
            var selectedCurrency = selectToTrack.options[selectToTrack.selectedIndex].value.toUpperCase();

            if (currencyToCheck.indexOf(selectedCurrency) !== -1) {
                return true;
            }
        }

        return false;
    }
};